import { render, staticRenderFns } from "./SectorDelete.vue?vue&type=template&id=54d0a546&"
import script from "./SectorDelete.vue?vue&type=script&lang=js&"
export * from "./SectorDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports